import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
/**
 * @Description This function returns Log section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Logs ({ error, setError }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    return (
        <>
            <IconButton className="vtest-close" size="small" onClick={() => setError(false)}>
                <ArrowBackIos fontSize="small" />
            </IconButton>
            <div className="verror vh1">{t(label + 'YOUR-ACTION')}</div>
            <div className="verror">{t(label + 'ERROR')}</div>
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>{t(label + 'LOG')}</th>
                        <th>{t(label + 'TIME')}</th>
                    </tr>
                </thead>
                <tbody>
                    {/* {data.map((item, itemI) => */}
                    <tr className="vvariable">
                        <td>{1}.</td>
                        <td>{error?.res?.message}</td>
                        <td style={{ height: 41 }}>{(new Date()).toLocaleString()}</td>
                    </tr>
                    {/* )} */}
                </tbody>
            </table>
        </>
    );
}
export default Logs;